export default __webpack_public_path__ + "static/media/Edit.be804704.svg";